import React from "react";
import "./facilities.css";

const facilityConfig = [
  { key: "has_parking", label: "Parking", icon: "🅿️" },
  { key: "has_cafe", label: "Café", icon: "☕" },
  { key: "has_seating", label: "Spectator Seating", icon: "🪑" },
  { key: "has_vending", label: "Vending", icon: "🥤" },
  { key: "has_disability_access", label: "Wheelchair Access", icon: "♿" },
  { key: "has_changing_rooms", label: "Changing Rooms", icon: "🚻" },
  { key: "has_showers", label: "Showers", icon: "🚿" },
  { key: "has_toilets", label: "Toilets", icon: "🚽" },
  { key: "has_gym", label: "Gym", icon: "🏋️" },
  { key: "has_fitness_studio", label: "Fitness Studio", icon: "🧘" },
  { key: "has_community_room", label: "Community Room", icon: "🏠" },
];

const Facilities = ({ court }) => {
  console.log("FACILITIES COURT OBJECT:", court);

  const availableFacilities = facilityConfig.filter(({ key }) => court[key]);
  console.log("AVAILABLE FACILITIES:", availableFacilities);

  if (availableFacilities.length === 0) return null;

  return (
    <div className="court-item-facilities">
      <div className="facility-icons">
        <strong>Facilities: </strong>
        {availableFacilities.map(({ key, label, icon }) => (
          <span key={key} title={label} className="facility-item">
            {icon} {label}
          </span>
        ))}
      </div>
    </div>
  );
};

export default Facilities;
